// extracted by mini-css-extract-plugin
export default {"home":"styles_home__LhShF","song":"styles_song__KKXHY","homeGrid":"styles_homeGrid__7uE7j","rightArea":"styles_rightArea__skWvD"};